export default [
  {
    title: 'Welcome',
    element: 'body',
    text: 'Welcome to Idonia, your medical image sharing platform. In this tour we will help you getting started.'
  },
  {
    title: 'My Space',
    element: '.idonia-header .toolbar__title',
    text: 'In "My Space" you will find all your folder, documents and studies stored in Idonia.'
  },
  {
    title: '"+" Button',
    element: '.action-fab button',
    text: 'Use this menu to create a folder, upload a file or folder from your device.',
    clickNext: 'nav button',
    wait: 150,
    placement: {
      relativeTo: 'viewport',
      position: 'top'
    }
  },
  {
    title: 'Shared Files',
    element: 'a[data-name="shared"]',
    text: 'In "shared with me" you can see the cases that SERAM has shared with you as well as other files and folders shared by other users.',
    clickBack: 'nav button',
    wait: 150
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/en-US/seram2018.js